import { render, staticRenderFns } from "./bottom_web.vue?vue&type=template&id=60a078d0&scoped=true"
import script from "./bottom_web.vue?vue&type=script&lang=js"
export * from "./bottom_web.vue?vue&type=script&lang=js"
import style0 from "./bottom_web.vue?vue&type=style&index=0&id=60a078d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a078d0",
  null
  
)

export default component.exports